import {
  ADICIONAR_FILTRO_PONTO_EMBARQUE,
  REMOVER_FILTRO_PONTO_EMBARQUE,
  LIMPAR_FILTRO_PONTO_EMBARQUE,
  BUSCAR_PONTOS_EMBARQUE_FILTRADO
} from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

export const filtrosAdicionadosPontoEmbarque = (state = [], action = {}) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_PONTO_EMBARQUE: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }
    case REMOVER_FILTRO_PONTO_EMBARQUE: {
      return state.filter(filtro =>
        filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor
      )
    }
    case LIMPAR_FILTRO_PONTO_EMBARQUE: {
      return []
    }
    default:
      return state
  }
}

export const pontoEmbarqueFiltrado = (state = { pontos: [], total: 0 }, action = {}) => {
  switch (action.type) {
    case BUSCAR_PONTOS_EMBARQUE_FILTRADO: {
      return action.payload.data
    }
    default:
      return state
  }
}
